module.exports = __webpack_public_path__ + "static/media/OBGYN-Obstetric History-1@3x.bbe01a52.png";